import {buildingGroup, clearStates, tmpGroup, toggleModeButtons} from "../../main";
import {clearGroup} from "../../sceneManager";
import {RoomLinePreview} from "./roomLine";
import * as Globals from "../../globals";
import {setActiveMode} from "../../globals";
import {createRooms} from "./roomGeneration";
import {findChildrenByName, setMaterial} from "../../utils/threeUtils";
import {lineMaterial} from "../../constants/materialConstants";

let currentPreview = null;

export function startRoomLinePreview() {
    setActiveMode(Globals.modes.roomSeparation);
    if (currentPreview === null) {
        currentPreview = new RoomLinePreview();
    }
}

export function adjustRoomLinePreview() {
    if (currentPreview === null) {
        console.error("Currently no separating line preview exists");
        return;
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            currentPreview.adjustFirstPreview();
        } else {
            currentPreview.adjustSecondPreview();
        }
    } else {
        console.error("No first preview mesh for wall exists");
    }
}

export function roomLineClick() {
    if (currentPreview === null) {
        console.error("Currently no wall preview exists");
        return;
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            currentPreview.createSecondPreview();
        } else {
            let keepAdding = currentPreview.createRoomLineFromPreview();
            if (!keepAdding) {
                currentPreview = null;
                clearStates();
                createRooms();
                toggleModeButtons();
            }
        }
    } else {
        console.error("No first preview mesh for wall exists");
    }
}

export function clearRoomLineState() {
    clearGroup(tmpGroup);
    if (currentPreview !== null) {
        clearGroup(currentPreview.group);
        currentPreview.group.removeFromParent();
    }
    currentPreview = null;
    resetRoomLineMaterials();
}

export function resetRoomLineMaterials() {
    let roomLineGroups = findChildrenByName(buildingGroup, "roomLineGroup");
    for (let i = 0; i < roomLineGroups.length; i++) {
        setMaterial(roomLineGroups[i], lineMaterial, true);
    }
}

export function deleteRoomLine(roomLineGroup) {
    clearGroup(roomLineGroup);
    roomLineGroup.removeFromParent();
    createRooms();
}
